var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2763 25.4836L13.015 23.3048C13.535 22.6248 14.545 23.4936 13.975 24.1436C13.3763 24.8536 12.7463 25.6236 12.1463 26.4123L14.185 28.9511C14.735 29.7011 13.6363 30.4198 13.0963 29.6798L11.2563 27.3211L9.4475 29.7311C8.9375 30.4598 7.8075 29.6411 8.3775 28.9611L10.3863 26.4123C9.75625 25.6223 9.14625 24.8536 8.5375 24.1436C7.90875 23.3936 9.0775 22.6248 9.5375 23.3261L11.2763 25.4836Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4188 23.6837C15.4188 23.3537 15.6988 23.0737 16.0488 23.0737C16.3688 23.0737 16.6388 23.355 16.6388 23.6837V28.6912H19.3575C20.3363 28.6912 20.3575 30 19.3575 30H16.05C15.7 30 15.42 29.7512 15.42 29.3912V23.6837H15.4188Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2525 24.5837C21.4825 22.6437 24.41 22.2949 25.79 23.3549C26.47 23.9037 25.75 24.7737 25.15 24.3337C24.41 23.8649 22.7313 23.6449 22.5213 24.6824C22.2513 26.3224 26.5988 25.3837 26.5288 28.0424C26.4588 30.5812 22.7813 30.6399 21.4013 29.5012C21.07 29.2312 21.0813 28.7924 21.2613 28.5212C21.5213 28.2624 21.81 28.1724 22.1513 28.4524C22.97 29.0112 25.08 29.4312 25.2288 28.0112C25.1 26.5337 20.9425 27.4224 21.2525 24.5837Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.46e779f216ae330d9530e780dab6edd1.svg";
export { ForwardRef as ReactComponent };